<template>
  <div
    ref="recaptchaContainer"
    class="recaptcha-v3-container"
  />
</template>

<script>
import { loadRecaptchaScript } from '@/libs/recaptcha'

export default {
  name: 'RecaptchaInvisible',
  props: {
    sitekey: {
      type: String,
      default: process.env.VUE_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    },
    action: {
      type: String,
      default: 'login',
    },
  },
  data() {
    return {
      isLoaded: false,
      currentToken: '',
    }
  },
  computed: {
    effectiveSiteKey() {
      if (typeof this.sitekey === 'function') {
        return this.sitekey() || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
      }
      return this.sitekey || process.env.VUE_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
    },
  },
  mounted() {
    this.initRecaptcha()
  },
  methods: {
    async initRecaptcha() {
      try {
        await loadRecaptchaScript(this.effectiveSiteKey)
        if (window.grecaptcha) {
          window.grecaptcha.ready(() => {
            this.isLoaded = true
            this.$emit('ready')
          })
        }
      } catch (error) {
        this.$emit('error', error)
      }
    },
    async execute(actionName) {
      const action = actionName || this.action || 'login'
      try {
        await loadRecaptchaScript(this.effectiveSiteKey)
        if (!window.grecaptcha || typeof window.grecaptcha.execute !== 'function') {
          this.$emit('verify', '')
          return ''
        }

        return await new Promise((resolve, reject) => {
          window.grecaptcha.ready(async () => {
            try {
              const token = await window.grecaptcha.execute(this.effectiveSiteKey, { action })
              this.currentToken = token
              this.$emit('verify', token)
              resolve(token)
            } catch (err) {
              this.$emit('error', err)
              reject(err)
            }
          })
        })
      } catch (error) {
        this.$emit('error', error)
        return ''
      }
    },
    reset() {
      this.currentToken = ''
    },
    getResponse() {
      return this.currentToken
    },
  },
}
</script>
